import script from "./Iframe.vue?vue&type=script&setup=true&lang=js"
export * from "./Iframe.vue?vue&type=script&setup=true&lang=js"

import "./Iframe.vue?vue&type=style&index=0&id=7eac4f20&scoped=true&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7eac4f20"]])

export default __exports__